<template>
  <b-modal id="screening2Modal" size="lg" centered modal-class="content-modal" no-stacking no-close-on-backdrop hide-footer @shown="modalShown">
    <template #modal-header="{ close }">
      <div class="modal-close-button">
        <b-button variant="close-button" title="Close modal pop up" @click="close()"></b-button>
      </div>
      <h3 class="modal-title h-underline" id="screening2ModalLabel">I think it would be embarrassing or awkward to get screened</h3>
    </template>

    <b-row>
      <b-col md="12">
        <p>Play the video to find out the advice from a nurse.</p>
        <VideoArea :video="video1"></VideoArea>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import VideoArea from "../../components/VideoArea";

export default {
  name: "Screening2",

  components: {
    VideoArea,
  },

  methods: {
    modalShown() {
      this.$emit("opened", 5);
    },
  },

  data: function() {
    return {
      video1: {
        id: 1,
        source: {
          plain: "./media/screeningforcancer/screening2/screening2.mp4",
        },
        captions: "./media/screeningforcancer/screening2/screening2-captions.vtt",
        poster: "./media/screeningforcancer/screening2/screening2-thumbnail.jpg",
      },
    };
  },
};
</script>
